module.exports = __webpack_public_path__ + "static/6305-woodrose-21-a1c8d9309259ce1a00b51a94aaa88cd4.jpg";